import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { LkpExpenssesModel } from 'src/app/models/LkpExpenssesModel';
import { LkpExpenssesService } from 'src/app/services/LkpExpenssesService';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-expenses-search',
  templateUrl: './expenses-search.component.html',
  styleUrls: ['./expenses-search.component.css']
})
export class ExpensesSearchComponent implements OnInit {
  expcode = '' ;
  expname = '' ;
  expnotes = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = '2024-01-01' ;

  expensesList: LkpExpenssesModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();

  constructor(public expensesservice : LkpExpenssesService,
    public storage: LocalStorageService,
    public lkpexpenses : LkpExpenssesModel,
    public dialogRef: MatDialogRef<ExpensesSearchComponent>,) { }

  ngOnInit(): void {
    this.retriveExpensesLookupTop();
  }
  retriveExpensesLookupTop(){
    this.expensesList = [];
    this.expensesservice.getExpenssesLookupTop(this.storage.retrieve('stgcompcode')).subscribe((data: LkpExpenssesModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.expensesList[i] = data[i];
      }
  });
 }
 retriveExpensesLookup(){

 }
 SelectExpenses(Pro : LkpExpenssesModel){
   this.lkpexpenses.expcode = Pro.expcode
   this.lkpexpenses.expname = Pro.expname
   this.lkpexpenses.expnotes= Pro.expnotes

   this.lkpexpenses.userid = Pro.userid
   this.lkpexpenses.modifieddate = Pro.modifieddate
   this.lkpexpenses.compcode = Pro.compcode
   this.submitClicked.emit(this.lkpexpenses);
   this.dialogRef.close();
 }
}
